import React, { useContext } from 'react';
import CustomSelector from '@shared/components/CustomSelector';
import { EVENT_APPRAISER_ASSIGNMENT_ROLE } from '../../../constants/EventAppraiserAssignmentRole';
import { EventTypeContext } from '../../shared/contexts/EventTypeContext';
import { ROLE_FIELD } from './constants/EventAssignmentsTableConstants';

/**
 * @typedef {object} EventAssignmentsTableRoleColumnRowRecord
 * @property {number} externalUserId
 */

/**
 * @typedef {object} EventAssignmentsTableRoleColumnProps
 * @property {number} atmRoleValue
 * @property {(externalUserId: number, newValue: number | string | null, field: string) => void} setATMValue
 * @property {EventAssignmentsTableRoleColumnRowRecord} rowRecord
 * @property {boolean} isAssignmentFilled
 * @property {boolean} [disabled]
 */

/**
 * @param {EventAssignmentsTableRoleColumnProps} props
 */
const EventAssignmentsTableRoleColumn = props => {
  const { atmRoleValue, setATMValue, rowRecord, isAssignmentFilled, disabled = false } = props;

  const eventTypeConfig = useContext(EventTypeContext);
  const atmRoleOptions = eventTypeConfig?.atmRoleOptions;

  const roleOptions = isAssignmentFilled
    ? atmRoleOptions.map(option =>
        option.value === EVENT_APPRAISER_ASSIGNMENT_ROLE.PRIMARY
          ? { ...option, disabled: true }
          : option
      )
    : atmRoleOptions;

  return (
    <CustomSelector
      name='Assignment'
      options={roleOptions}
      value={atmRoleValue}
      setValue={newValue => {
        setATMValue(rowRecord.externalUserId, newValue, ROLE_FIELD);
      }}
      testId='select-role'
      disabled={disabled}
    />
  );
};

export default EventAssignmentsTableRoleColumn;
